/**
 * カートの更新に失敗して表示が古いあいだ、
 * 「ご注文手続きへ進む」を「カートを更新する」に差し替える。
 *
 * なぜ要るか（2026-10-02）:
 *   数量変更で /cart/change.js が 422 や 409 を返すと、Dawn の cart.js は
 *   そのレスポンスを成功として扱い、存在しない parsedState.sections を読んで落ちる。
 *   結果 .catch() に入り「カートをアップデートするときにエラーが発生しました」が出る。
 *   **このときサーバーのカートは既に変わっている**（在庫上限に丸められる等）のに、
 *   画面は変更前のまま。お客様は古い金額を見ながらチェックアウトできてしまう。
 *
 *   例: 在庫以上の数量を入れると 422 ＋「アイテム50点のみが…」が返り、
 *       サーバーのカートは 50 点になるが、画面は元の数量・元の合計のまま。
 *
 * やっていること:
 *   #cart-errors / #CartDrawer-CartErrors に文字が入っているあいだ、
 *   チェックアウトボタンの文言を data-lmtm-refresh-label に差し替え、
 *   押されたら送信せずにページを読み直す。
 *   エラーが消えれば（＝更新が成功してセクションが描き直されれば）文言も戻る。
 *
 *   ⚠️ **元から disabled のボタンには触らない。**
 *      カートが空のときの disabled はテーマが付けているもの。
 *   ⚠️ **data-lmtm-refresh-label が無いときは、押せなくするほうに倒す。**
 *      文言が無いまま「進める」状態で放置しないため。
 *
 * これは表示と中身のズレを「進ませない」ことで防ぐだけで、ズレ自体は直さない。
 * ズレを直す対応（本当のエラーメッセージを出して表示を同期する）は別途。
 */
(function () {
  'use strict';

  var ERROR_BOXES = '#cart-errors, #CartDrawer-CartErrors';
  var CHECKOUT = '[name="checkout"]';
  var STALE_CLASS = 'lmtm-cart-stale';
  var FLAG = 'data-lmtm-cart-refresh';

  function hasError() {
    var boxes = document.querySelectorAll(ERROR_BOXES);
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].textContent.trim() !== '') return true;
    }
    return false;
  }

  function toRefresh(btn) {
    if (btn.hasAttribute(FLAG)) return;
    var label = btn.getAttribute('data-lmtm-refresh-label');
    if (!label) {
      /* 文言が用意されていないテンプレート。進ませないことを優先する */
      if (!btn.disabled) {
        btn.setAttribute('data-lmtm-cart-blocked', '1');
        btn.disabled = true;
      }
      return;
    }
    btn.setAttribute('data-lmtm-cart-original', btn.innerHTML);
    btn.setAttribute(FLAG, '1');
    btn.textContent = label;
  }

  function toCheckout(btn) {
    if (btn.hasAttribute(FLAG)) {
      btn.innerHTML = btn.getAttribute('data-lmtm-cart-original') || btn.innerHTML;
      btn.removeAttribute('data-lmtm-cart-original');
      btn.removeAttribute(FLAG);
    }
    if (btn.hasAttribute('data-lmtm-cart-blocked')) {
      btn.removeAttribute('data-lmtm-cart-blocked');
      btn.disabled = false;
    }
  }

  function sync() {
    var stale = hasError();
    document.documentElement.classList.toggle(STALE_CLASS, stale);

    var buttons = document.querySelectorAll(CHECKOUT);
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      /* 元から disabled（＝カートが空）のものは触らない。
         ただし自分が disabled にしたものは戻す対象。 */
      if (stale) {
        if (!btn.disabled || btn.hasAttribute('data-lmtm-cart-blocked')) toRefresh(btn);
      } else {
        toCheckout(btn);
      }
    }
  }

  /* 「カートを更新する」状態のクリックは送信せず読み直す。
     capture で拾って、テーマ側のハンドラより先に止める。 */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[' + FLAG + ']') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.reload();
    },
    true
  );

  /* Enter キーなどでフォームが出てしまう経路も塞ぐ。
     数量の変更は JS（fetch）なのでフォーム送信とは別。
     ここで止まるのはチェックアウトへの送信だけ。 */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      if (!hasError()) return;
      var by = e.submitter;
      if (by && by.name !== 'checkout') return;
      e.preventDefault();
    },
    true
  );

  function start() {
    sync();
    if (typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(sync);
    /* エラー欄はセクション再描画でまるごと差し替わるので、
       欄そのものではなく「差し替わらない親」を見る。 */
    var roots = ['#main-cart-footer', '#main-cart-items', 'cart-drawer'];
    for (var i = 0; i < roots.length; i++) {
      var el = document.querySelector(roots[i]);
      if (el) obs.observe(el, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
